import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["open", "title", "description", "handleYes", "handleNo", "yesLabel", "noLabel"];
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
export default function YesNoDialog(_ref) {
  var open = _ref.open,
    title = _ref.title,
    description = _ref.description,
    handleYes = _ref.handleYes,
    handleNo = _ref.handleNo,
    yesLabel = _ref.yesLabel,
    noLabel = _ref.noLabel,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Dialog, Object.assign({
    open: open,
    onClose: handleNo
  }, props), /*#__PURE__*/React.createElement(DialogTitle, {
    id: "alert-title"
  }, title), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
    id: "alert-description"
  }, description)), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleNo,
    color: "primary"
  }, noLabel || "No"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleYes,
    color: "primary",
    autoFocus: true
  }, yesLabel || "Yes")));
}